var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ant-pro-global-header-index-right"},[_c('avatar-dropdown',{class:_vm.prefixCls,attrs:{"menu":_vm.showMenu,"current-user":_vm.currentUser}}),_c('select-lang',{class:_vm.prefixCls})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }